import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { eDmNhomLoaiThuChiActionsObj } from "./../../action-types/category/IDmNhomLoaiThuChiActions";

export const nhomloaiThuChiActions = {
  ...generateActions(eDmNhomLoaiThuChiActionsObj, "NHOM_LOAI_THU_CHI"),
  ...generateActionForKey(
    eDmNhomLoaiThuChiActionsObj,
    "NHOM_LOAI_THU_CHI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDmNhomLoaiThuChiActionsObj,
    "NHOM_LOAI_THU_CHI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmNhomLoaiThuChiActionsObj,
    "NHOM_LOAI_THU_CHI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDmNhomLoaiThuChiActionsObj,
    "NHOM_LOAI_THU_CHI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
